import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import HomeCategorieDetails from "../../../Components/Modal/supplier_app/HomeIntro/HomeCategorieDetails";
import { useSelector } from "react-redux"; //useDispatch
import "./homeIntro.scss";
import CategoryCard from "../../../Components/Cards/CategoryCard";
import StatusDonutChartCard from "../../../Components/Cards/StatusDonutChart";
import StatsGrid from "../../../Components/Cards/StatsGrid";
import ItemService3 from "../../../services/ap_auto_appCommonService";
import {
  ClockIcon,
  CheckBadgeIcon,
  BanknotesIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
  DocumentTextIcon,
  CheckCircleIcon,
  CalendarDaysIcon,
  SunIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import HomeIntorVideo from "../../../Components/Modal/supplier_app/HomeIntro/HomeIntorVideo";
import HRConstants from "../../../common/HRConstants";
import CollapseCard from "../../../Components/Collapsecard/Collapsecard";
import {
  Banknote,
  Building2,
  CheckCircle,
  FileText,
  FolderKanban,
  Users,
} from "lucide-react";
const HomeIntro = () => {
  const currentDate = new Date();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Home");
  localStorage.setItem("submenu", "-");
  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  let userData = useSelector((state) => state?.user?.data); // User Details from Store
  const firstName = userData?.firstName || "User";
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) return "Good Morning";
    if (hour >= 12 && hour < 17) return "Good Afternoon";
    if (hour >= 17 && hour < 21) return "Good Evening";
    return "Good Night";
  };
  // eslint-disable-next-line no-unused-vars
  const [totalPostDispatchCountStatus, setTotalPostDispatchCountStatus] =
    useState(false);

  const [productdata, setProductdata] = useState({});
  const [statusCountData, setStatusCountData] = useState([]);
  const [getattendance, setAttendance] = useState();
  useEffect(() => {
    setProductdata(appConfig?.homeIntro);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appConfig]);
  // Format the date (optional)
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // const [getIntroVideo, setIntroVideo] = useState(false);
  const [getCategoryDetail, setCategoryDetail] = useState(false);

  const [getVideoPath, setVideoPath] = useState();

  const [getIntroVideo, setIntroVideo] = useState(false);
  const introVideoShow = (getVideoPath) => {
    setIntroVideo(true);
    setVideoPath(getVideoPath);
  };

  const introVideoHide = () => {
    setIntroVideo(false);
  };

  let purchaseOrderData = useSelector(
    (state) => state?.purchasing?.purchase_order,
  ); // get purchaseOrderData from Store

  const loadInitialPOData = async () => {
    setData(purchaseOrderData?.data);
  };

  useEffect(() => {
    loadInitialPOData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseOrderData]);

  // eslint-disable-next-line
  const [data, setData] = useState([]);

  const [moduleStats, setModuleStats] = useState({});
  useEffect(() => {
    if (moduleStats?.task?.chartData) {
      const customerData = moduleStats.task.chartData.map((item) => ({
        name: item.status || "Unknown",
        count: item.count,
      }));

      setStatusCountData(customerData);
    }
    if (moduleStats?.attendance?.chartData) {
      const attenadanceData = moduleStats.attendance.chartData.map((item) => ({
        name: item.status || "Unknown",
        count: item.count,
      }));

      setAttendance(attenadanceData);
    }
  }, [moduleStats]);
  const loadModuleStats = async () => {
    try {
      const payload = {
        dashboard: "hr_module",
        chartFilterType: "Yearly",
        chartInput2: new Date().getFullYear(),
      };
      const res = await ItemService3.getModuleStats(payload); // use your actual service method
      if (res?.status === 200) {
        setModuleStats(res?.data);
      }
    } catch (err) {
      console.log("Failed to load module stats", err);
    }
  };

  useEffect(() => {
    loadModuleStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const categoryConfigs = [
    {
      title: "Employee",
      icon: Users,
      navigateKey: "emp",
      directCount: moduleStats?.employee?.total ?? 0,
      value: moduleStats?.employee?.sum ?? 0,
    },
    {
      title: "HR Documents",
      icon: FileText,
      navigateKey: "hrDoc",
      directCount: moduleStats?.hrDoc?.total ?? 0,
      value: moduleStats?.hrDoc?.sum ?? 0,
    },
    {
      title: "Task",
      icon: CheckCircle,
      navigateKey: "task",
      directCount: moduleStats?.task?.total ?? 0,
      value: moduleStats?.task?.sum ?? 0,
    },
    {
      title: "Expenses",
      icon: Banknote,
      navigateKey: "expenses",
      directCount: moduleStats?.expenses?.total ?? 0,
      value: moduleStats?.expenses?.sum ?? 0,
    },
    {
      title: "Receipts",
      icon: Banknote,
      navigateKey: "receipts",
      directCount: moduleStats?.receipts?.total ?? 0,
      value: moduleStats?.receipts?.sum ?? 0,
    },
    {
      title: "Clients",
      icon: Building2,
      navigateKey: "clients",
      directCount: moduleStats?.client?.total ?? 0,
      value: moduleStats?.client?.sum ?? 0,
    },
    {
      title: "Projects",
      icon: FolderKanban,
      navigateKey: "projects",
      directCount: moduleStats?.project?.total ?? 0,
      value: moduleStats?.project?.sum ?? 0,
    },
  ];
  const queryConfigs = [
    {
      title: "Created Task",
      icon: DocumentTextIcon,
      directCount:
        moduleStats?.task?.chartData?.find((item) => item.status === "Created")
          ?.count ?? 0,
    },
    {
      title: "Started Task",
      icon: ClockIcon,
      directCount:
        moduleStats?.task?.chartData?.find((item) => item.status === "Started")
          ?.count ?? 0,
    },
    {
      title: "In Progress Task",
      icon: CheckBadgeIcon,
      directCount:
        moduleStats?.task?.chartData?.find(
          (item) => item.status === "In Progress",
        )?.count ?? 0,
    },
    {
      title: "On Hold Task",
      icon: BanknotesIcon,
      directCount:
        moduleStats?.task?.chartData?.find((item) => item.status === "On Hold")
          ?.count ?? 0,
    },
    {
      title: "Closed Task",
      icon: XCircleIcon,
      directCount:
        moduleStats?.task?.chartData?.find((item) => item.status === "Closed")
          ?.count ?? 0,
    },
    {
      title: "Transferred Task",
      icon: ExclamationTriangleIcon,
      directCount:
        moduleStats?.task?.chartData?.find(
          (item) => item.status === "Transferred",
        )?.count ?? 0,
    },
    {
      title: "Cancelled Task",
      icon: ArrowUturnLeftIcon,
      directCount:
        moduleStats?.task?.chartData?.find(
          (item) => item.status === "Cancelled",
        )?.count ?? 0,
    },
    {
      title: "Deleted Task",
      icon: ArrowUturnRightIcon,
      directCount:
        moduleStats?.task?.chartData?.find((item) => item.status === "Deleted")
          ?.count ?? 0,
    },
  ];
  //   {
  //     queryName: "Get_RFX_Cancelled_Count_value",
  //     title: "Created Task",
  //     icon: DocumentTextIcon,
  //   },
  //   {
  //     queryName: "Get_Quotation_Count_value",
  //     title: "Started Task",
  //     icon: ClockIcon,
  //   },
  //   {
  //     queryName: "Get_RFXTE_Count_value",
  //     title: "In Progress Task",
  //     icon: CheckBadgeIcon,
  //   },
  //   {
  //     queryName: "Get_RFXCE_Count_value",
  //     title: "On Hold Task",
  //     icon: BanknotesIcon,
  //   },
  //   {
  //     queryName: "Get_ASN_Count_value",
  //     title: "Closed Task",
  //     icon: XCircleIcon,
  //   },
  //   {
  //     queryName: "Get_PR_Count_value",
  //     title: "Transferred Task",
  //     icon: ExclamationTriangleIcon,
  //   },
  //   {
  //     queryName: "Get_Gatepass_Count_value",
  //     title: "Credit Memo",
  //     icon: ArrowUturnLeftIcon,
  //   },
  //   {
  //     queryName: "Get_GRN_Count_value",
  //     title: "Debit Memo",
  //     icon: ArrowUturnRightIcon,
  //   },
  // ];
  const attendance = [
    {
      title: "Present",
      icon: CheckCircleIcon,
      directCount:
        moduleStats?.attendance?.chartData?.find(
          (item) => item.status?.toLowerCase() === "present",
        )?.count ?? 0,
    },
    {
      title: "Absent",
      icon: XCircleIcon,
      directCount:
        moduleStats?.attendance?.chartData?.find(
          (item) => item.status?.toLowerCase() === "absent",
        )?.count ?? 0,
    },
    {
      title: "Late",
      icon: ClockIcon,
      directCount:
        moduleStats?.attendance?.chartData?.find(
          (item) => item.status?.toLowerCase() === "late",
        )?.count ?? 0,
    },
    {
      title: "On Leave",
      icon: CalendarDaysIcon,
      directCount:
        moduleStats?.attendance?.chartData?.find(
          (item) => item.status?.toLowerCase() === "on leave",
        )?.count ?? 0,
    },
    {
      title: "Holiday",
      icon: SunIcon,
      directCount:
        moduleStats?.attendance?.chartData?.find(
          (item) => item.status?.toLowerCase() === "holiday",
        )?.count ?? 0,
    },
  ];

  const navigateToMainPage = (page) => {
    if (page === "emp") {
      navigate(HRConstants.HR_EMP_LIST);
    } else if (page === "task") {
      navigate(HRConstants.HR_TASK_LIST);
    } else if (page === "hrDoc") {
      navigate(HRConstants.HR_DOC_LIST);
    } else if (page === "expenses") {
      navigate(HRConstants.HR_EXPENSES_LIST);
    } else if (page === "clients") {
      navigate(HRConstants.HR_CLIENT_LIST);
    } else if (page === "projects") {
      navigate(HRConstants.HR_PROJECT_LIST);
    }
  };
  // eslint-disable-next-line no-unused-vars
  const categoryDetailShow = () => {
    // setCategoryDetail(true);
  };

  const categoryDetailHide = () => {
    setCategoryDetail(false);
  };

  const ProductSection = ({ data }) => {
    return (
      <Row className="homeintroposter">
        {/* Product Info Section */}
        <Col
          xs={12}
          md={12}
          lg={12}
          className="postertext d-flex justify-content-center align-items-center flex-column mb-4"
        >
          <p className="fw-bold ms-2 fs-3">{data?.mainTitle}</p>
          <div className="smarthub">
            <p className="fs-5 fw-bold ms-2">{data?.subTitle}</p>
          </div>
        </Col>
        {/* Loop through products */}

        {data?.products?.map((product, index) => (
          <Col
            key={index}
            xs={12}
            md={2}
            lg={2}
            className="d-flex flex-column align-items-center p-2"
          >
            <div className="image-box d-flex justify-content-center align-items-center">
              <img
                className="img-fluid"
                src={product?.image}
                alt={product?.alt}
              />
            </div>
            <p className="fs-5 fw-bold m-0">{product?.name}</p>
          </Col>
        ))}
      </Row>
    );
  };

  return (
    <main className="dashboard main customer" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row className="home-intro">
              <Col xs={12} md={12} lg={12} className="headers p-2 mb-2">
                <Row className="align-items-center">
                  {/* LEFT SECTION */}
                  <Col xs={12} md={3}>
                    <h4 className="greeting">
                      <span className="morningText">{getGreeting()}</span>,{" "}
                      <span className="userName">{firstName}</span> 👋
                    </h4>
                    <h5 className="welcome">
                      Welcome to <span className="portal">HR Portal</span>
                    </h5>
                  </Col>

                  {/* CENTER SECTION */}
                  <Col xs={12} md={7} className="text-center">
                    <div className="d-flex justify-content-center align-items-center">
                      {appConfig?.customerLogo1 && (
                        <img
                          className="img-fluid introCustomerlogo"
                          src={appConfig?.customerLogo1}
                          alt="logo1"
                        />
                      )}

                      <p className="fw-bold ms-2 fs-2 mb-0">
                        {appConfig?.customerName}
                      </p>

                      {appConfig?.customerLogo2 && (
                        <img
                          className="img-fluid ms-2"
                          src={appConfig?.customerLogo2}
                          alt="logo2"
                        />
                      )}
                    </div>
                  </Col>

                  {/* RIGHT SECTION (DATE AT END) */}
                  <Col xs={12} md={2} className="d-flex justify-content-end">
                    <div className="date">
                      <InputField
                        className="inputBox"
                        value={formattedDate}
                        disabled
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              <div className="col-lg-12 px-0 mb-1">
                <CollapseCard title="My Category">
                  <div className="row g-3 mt-0 align-items-start">
                    <div className="row g-3">
                      {categoryConfigs.map((item, index) => (
                        <div
                          className="col-12 col-md-6 col-lg-3 px-2 py-0"
                          key={index}
                        >
                          <CategoryCard
                            {...item}
                            onClick={() => navigateToMainPage(item.navigateKey)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </CollapseCard>
              </div>
              {/* Supplier / vendor */}
              <div className="col-lg-12 px-0 mb-1">
                <CollapseCard title="Task Statics">
                  <div className="row g-3 mt-0 align-items-start">
                    <div className="col-12 col-lg-4 d-flex">
                      <StatusDonutChartCard
                        title="Task Statics"
                        data={statusCountData}
                        className="w-100 h-100"
                      />
                    </div>

                    {/* RIGHT STATS GRID */}
                    <div className="col-12 col-lg-8 d-flex">
                      <div className="card w-100 h-100">
                        <div className="card-body p-0">
                          <StatsGrid
                            queryConfigs={queryConfigs}
                            // refreshInterval={30000}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </CollapseCard>
              </div>
              <div className="col-lg-12 px-0 mb-1">
                <CollapseCard title="Attendance Statics">
                  <div className="row g-3 mt-0 align-items-start">
                    <div className="col-12 col-lg-4 d-flex">
                      <StatusDonutChartCard
                        title="Attendance Statics"
                        data={getattendance}
                        className="w-100 h-100"
                      />
                    </div>
                    <div className="col-12 col-lg-8 d-flex">
                      <div className="card w-100 h-100">
                        <div className="card-body p-0">
                          <StatsGrid queryConfigs={attendance} />
                        </div>
                      </div>
                    </div>
                  </div>
                </CollapseCard>
              </div>
              <Col xs={12} md={12} lg={12} className="mb-2">
                <ProductSection data={productdata} />
              </Col>
              <Col xs={12} md={12} lg={12} className="headers mb-0 mt-0">
                <p className="title p-2">Process</p>
                <div className="d-flex overflow-auto mb-0 mt-0">
                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Vendor Management</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Procurement</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-file-earmark-check"></i>
                          </div>
                          <h5 className="card-title">Sourcing</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-card-list"></i>
                          </div>
                          <h5 className="card-title">Contract</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Auction</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/Spend_Analysis.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Spend Analysis</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* <HomeIntorVideo show={getIntroVideo} onHide={introVideoHide} videopath={getVideoPath} /> */}
      <HomeCategorieDetails
        show={getCategoryDetail}
        onHide={categoryDetailHide}
      />
      <HomeIntorVideo
        show={getIntroVideo}
        onHide={introVideoHide}
        videopath={getVideoPath}
      />
    </main>
  );
};
export default HomeIntro;
